module.exports = __webpack_public_path__ + "img/apnelistgraph.d6558a36.svg";